import {
  login,
  start,
  end,
  error,
  authorize,
  getSession,
  isLoggedIn,
  endSession,
  SESSION_AUTHORIZE,
  SESSION_START,
  SESSION_END,
  SESSION_ERROR,
} from '../Actions/AuthActions';

const authActionTypes = [ SESSION_AUTHORIZE, SESSION_START, SESSION_END, SESSION_ERROR ];

export default (store) => (next) => (action) => {
  const state = store.getState();
  const session = getSession();

  //console.log(action);

  const authState = state.authorization;
  //console.log('running', authState, session);
  if (!authState.access_token && !session.access_token) {
    //if not authorized, begin authorizing
    //console.log('authorizing');
    authorize();
    return next(login());
  }

  //if logged in, but not yet recorded in state, let the state know
  //console.log(isLoggedIn());
  if (!authState.access_token && isLoggedIn()) {
    //console.log('starting');
    if (action.type !== SESSION_START) {
      store.dispatch(start(session.jwt, session.access_token));
    }
    return next(action);
  }

  //if action is not auth related check for expired session and logout if so
  if (!authActionTypes.includes(action.type)) {
    //if (authState.access_token && !isLoggedIn()) {
    if (!isLoggedIn()) {
      return store.dispatch(end());
    }
    return next(action);
  }

  // `session.error` is an error returned from pingdom's openid flow
  if (session.error) return next(error(session));

  //remove token from session storage on logout
  if (action.type === SESSION_END) {
    endSession();
    return next(end());
  }

  return next(action);
};



// WEBPACK FOOTER //
// ./src/Middleware/auth.middleware.js